export type AppEnv = {
  treasurySafe: string
  stngProxy: string
  operationalSafeFactory: string
  operationalSafeGuard: string
  mainnetRpcUrl?: string
  sepoliaRpcUrl?: string
  apiUrl?: string
  adminBearerToken: string
  demoPrivateKey?: `0x${string}`
}

function required(name: string, value: string | undefined): string {
  if (!value) {
    throw new Error(`Missing required env var: ${name}`)
  }
  return value
}

export function getEnv(): AppEnv {
  const treasurySafe = required(
    'VITE_TREASURE_CONTRACT_ADDRESS',
    import.meta.env.VITE_TREASURE_CONTRACT_ADDRESS
  )
  const stngProxy = required(
    'VITE_STNG_TOKEN_CONTRACT_ADDRESS',
    import.meta.env.VITE_STNG_TOKEN_CONTRACT_ADDRESS
  )
  const operationalSafeFactory = required(
    'VITE_SAFE_FACTORY_CONTRACT_ADDRESS',
    import.meta.env.VITE_SAFE_FACTORY_CONTRACT_ADDRESS
  )
  const operationalSafeGuard = required(
    'VITE_SAFE_GUARD_CONTRACT_ADDRESS',
    import.meta.env.VITE_SAFE_GUARD_CONTRACT_ADDRESS
  )
  const mainnetRpcUrl = import.meta.env.VITE_MAINNET_RPC_URL
  const sepoliaRpcUrl = import.meta.env.VITE_SEPOLIA_RPC_URL
  const apiUrl = import.meta.env.VITE_API_URL
  const adminBearerToken = required(
    'VITE_ADMIN_BEARER',
    import.meta.env.VITE_ADMIN_BEARER
  )
  const demoPrivateKey = import.meta.env['VITE_DEMO_PRIV_KEY'] as
    | `0x${string}`
    | undefined

  return {
    treasurySafe,
    stngProxy,
    operationalSafeFactory,
    operationalSafeGuard,
    mainnetRpcUrl,
    sepoliaRpcUrl,
    apiUrl,
    adminBearerToken,
    demoPrivateKey,
  }
}

export function getRpcUrlForChainId(chainId: number): string | undefined {
  const { mainnetRpcUrl, sepoliaRpcUrl } = getEnv()

  if (chainId === 1) {
    return mainnetRpcUrl
  }

  if (chainId === 11155111) {
    return sepoliaRpcUrl
  }

  return undefined
}
